import type { DataNode } from 'antd/es/tree';
import { NodeCard } from '../../../../HierarchicalTrees/TreeNodeCard';
export const buildRiskExposureTree = (data: any[]): DataNode[] => {
  const entityMap = new Map<string, any>();

  const display = (v?: string) => (v && v.trim() ? v : '—');

  const safe = (v: any) =>
    v && String(v).trim() ? String(v).trim() : '__empty__';

  const getOrCreate = (
    map: Map<string, any>,
    key: string,
    label: string,
    value: string,
    parent?: any,
  ) => {
    let node = map.get(key);

    if (!node) {
      node = {
        key,
        title: <NodeCard label={label} value={display(value)} />,
        children: [],
        value,
      };

      map.set(key, node);
      if (parent) parent.children.push(node);
    } else {
      if (value && (!node.value || node.value === '—')) {
        node.value = value;
        node.title = <NodeCard label={label} value={value} />;
      }

      if (parent && !parent.children.includes(node)) {
        parent.children.push(node);
      }
    }

    return node;
  };

  data.forEach((item, index) => {
    const entityKey = `entity-${safe(item.entity_name)}`;
    const entity = getOrCreate(
      entityMap,
      entityKey,
      'Entity',
      item.entity_name,
    );

    const tppKey = `${entityKey}/tpp-${safe(item.tpp_name)}-${index}`;
    const tppMap = entity.childrenMap ?? (entity.childrenMap = new Map());

    const tpp = getOrCreate(tppMap, tppKey, 'TPP', item.tpp_name, entity);

    const contractKey = `${tppKey}/contract-${safe(item.contract_name)}-${index}`;
    const contractMap = tpp.childrenMap ?? (tpp.childrenMap = new Map());

    const contract = getOrCreate(
      contractMap,
      contractKey,
      'Contract',
      item.contract_name,
      tpp,
    );

    const serviceKey = `${contractKey}/service-${safe(item.ict_service_name)}-${index}`;
    const serviceMap =
      contract.childrenMap ?? (contract.childrenMap = new Map());

    const service = getOrCreate(
      serviceMap,
      serviceKey,
      'Service',
      item.ict_service_name,
      contract,
    );

    const systemKey = `${serviceKey}/system-${safe(item.ict_system_name)}-${index}`;
    const systemMap = service.childrenMap ?? (service.childrenMap = new Map());

    const system = getOrCreate(
      systemMap,
      systemKey,
      'System',
      item.ict_system_name,
      service,
    );

    const riskKey = `${systemKey}/risk-${safe(item.ict_risk_name)}-${index}`;
    const riskMap = system.childrenMap ?? (system.childrenMap = new Map());

    const risk = getOrCreate(
      riskMap,
      riskKey,
      'Risk',
      item.ict_risk_name,
      system,
    );

    const depKey = `${riskKey}/dependency-${safe(item.dependency_type_name)}-${index}`;
    const depMap = risk.childrenMap ?? (risk.childrenMap = new Map());

    const dependency = getOrCreate(
      depMap,
      depKey,
      'Dependency',
      item.dependency_type_name,
      risk,
    );

    const expKey = `${depKey}/exposure-${safe(item.risk_exposure_name)}-${index}`;
    const expMap =
      dependency.childrenMap ?? (dependency.childrenMap = new Map());

    const exposure = getOrCreate(
      expMap,
      expKey,
      'Exposure',
      item.risk_exposure_name,
      dependency,
    );

    const catKey = `${expKey}/category-${safe(item.exposure_category_name)}-${index}`;
    const catMap = exposure.childrenMap ?? (exposure.childrenMap = new Map());

    getOrCreate(
      catMap,
      catKey,
      'Category',
      item.exposure_category_name,
      exposure,
    );
  });

  return Array.from(entityMap.values());
};
